import { JSONContent } from '@tiptap/core';

import { useRichtext } from 'approot/shared/richtext/richtext.hooks';
import { useInputFieldState } from '../../component.hooks';
import { BASE_FILL_IN_BLANKS_TEXT_BLOCK_SETTINGS } from '../fill-in-blanks.constants';
import RichtextInline from 'approot/shared/richtext/richtext-inline';

type Props = {
  initialValue: JSONContent | null;
  onChange: (json: JSONContent) => void;
};

const FillInBlanksSettingsTextField = ({ initialValue, onChange }: Props) => {
  const { setEditorStateToUpdate } = useInputFieldState<JSONContent>({
    onChange,
  });

  const { editor } = useRichtext({
    onChange: json => setEditorStateToUpdate(json),
    initialValue: initialValue ?? undefined,
    settings: BASE_FILL_IN_BLANKS_TEXT_BLOCK_SETTINGS,
  });

  return (
    <>
      {editor && <RichtextInline editor={editor} minHeight={42} excludeTools />}
    </>
  );
};

export default FillInBlanksSettingsTextField;
